import React, { useMemo, useState } from "react"
import { DateTime } from "luxon"

import { preventSleepyBuddies } from "@utils"

import Icon, { ICON_TYPES } from "@components/Icon/Icon"

import ClassesPageRegisterModal from "../ClassesPageRegisterModal/ClassesPageRegisterModal"

import {
  ClassesPageClassDetailsContentDIV,
  ClassesPageClassDetailsDIV,
  ClassesPageClassTimesDIV,
  ClassesPageClassTimesWrapperDIV,
  ClassesPageHeroRegisterBUTTON,
} from "./ClassesPageClassDetails.styles"

const ClassesPageClassDetails = ({
  color,
  times,
  title,
  description,
}) => {
  const [activeTime, setActiveTime] = useState(0)
  const [showModal, setShowModal] = useState(false)

  const classTimes = useMemo(() =>
    !times ? [] : times
      // Add the luxon timezone date object
      .map(time => {
        const dt = DateTime.fromISO(time.timestamp)
        return {
          ...time,
          dt,
        }
      })
      // Filter out any class times that have already happened
      .filter(({ dt }) => Date.now() < dt.toFormat("x"))
      // Limit to 6 classes
      .slice(0, 6)
    , [times])

  const hasTimes = classTimes.length > 0

  return (
    <>
      <ClassesPageClassDetailsDIV className={`ClassesPageClass ${color}${!hasTimes ? " is-empty" : ""}`}>
        <ClassesPageClassDetailsContentDIV>
          <h4 dangerouslySetInnerHTML={{ __html: preventSleepyBuddies(title) }} />
          <p>{description}</p>
        </ClassesPageClassDetailsContentDIV>
        <ClassesPageClassTimesWrapperDIV>
          <button
            className="back"
            onClick={() => { if (activeTime > 0) setActiveTime(activeTime - 1) }}
            style={{ opacity: activeTime > 0 ? 1 : 0 }}
            tabIndex={activeTime === 0 ? -1 : undefined}
          >
            <Icon type={ICON_TYPES["chevron-left"]} size="24px" />
          </button>
          <ClassesPageClassTimesDIV
            // let's talk about this thing below: `calc(
            // `-${activeTime} *` we move a certain amount of pixels (width of the date button, based on a css property) "activeTime" number of times to the left, hence the negative
            // `max(calc(var(--spacing--XL)*.75), 100px)` is the width of the date button
            // we need to account for the 20px of right margin on each button, so we move further to the left with `- calc(${activeTime} * 20px)`
            style={{ transform: `translateX(calc(-${activeTime} * max(calc(var(--spacing--XL)*.75), 100px) - calc(${activeTime} * 20px)))` }}
          >
            {hasTimes ?
              classTimes.map((classTime, i) => (
                <button
                  className={i === activeTime ? "is-active" : undefined}
                  key={classTime.timestamp}
                  onClick={() => setActiveTime(i)}
                  onKeyDown={e => {
                    // If the `enter` key is pressed...
                    if (e.which === 13) {
                      setShowModal(true)
                    }
                  }}
                  onFocus={() => setActiveTime(i)}
                  style={{ opacity: activeTime > i ? 0 : 1 }}
                >
                  <span className="month font--overline-S">{classTime.dt.toFormat("LLL")}</span>
                  <span className="date">{classTime.dt.toFormat("d")}</span>
                  <span className="time">{classTime.dt.toFormat("ha")} {classTime.dt.offsetNameShort}</span>
                </button>
              )) : Array(6).fill(null).map((_, i) => <div key={i} />)
            }
          </ClassesPageClassTimesDIV>
        </ClassesPageClassTimesWrapperDIV>
        {hasTimes ?
          (
            <ClassesPageHeroRegisterBUTTON
              className="font--text-M"
              onClick={() => setShowModal(true)}
            >
              Register
            </ClassesPageHeroRegisterBUTTON>
          ) : (
            <ClassesPageHeroRegisterBUTTON as="div">
              Check back for more classes soon
            </ClassesPageHeroRegisterBUTTON>
          )
        }
      </ClassesPageClassDetailsDIV>
      {showModal && (
        <ClassesPageRegisterModal
          onClose={() => setShowModal(false)}
          classTitle={title}
          classTime={classTimes[activeTime]}
        />
      )}
    </>
  )
}

export default ClassesPageClassDetails
